import { handleActions } from 'redux-actions';
import { actions } from '../actions/confirmModal';
const { confirmModalShow, confirmModalHide, confirmModalCancel, confirmModalConfirm, } = actions;
const initialState = {
    isShown: false,
    headline: '',
    text: '',
    cancelText: 'Cancel',
    confirmText: '',
};
const confirmModal = handleActions({
    [confirmModalShow.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isShown: true, headline: action.payload.headline, text: action.payload.text, cancelText: action.payload.cancelText || 'Cancel', confirmText: action.payload.confirmText });
    },
    [confirmModalHide.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isShown: false });
    },
    [confirmModalCancel.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isShown: false });
    },
    [confirmModalConfirm.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isShown: false });
    },
}, initialState);
export default confirmModal;
